const SELECT_REQUEST = 'employees/select/request'
const SELECT_SUCCESS = 'employees/select/success'
const SELECT_FAILURE = 'employees/select/failure'

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE }
